export const API_URL = process.env.REACT_APP_API_URL || '';
export const BASE_PATH = process.env.REACT_APP_BASE_PATH || '';
export const SENTRY_DSN = 'https://eca531b8ac1044f2962bb06cf4dc8948@o36975.ingest.sentry.io/5435866';
export const APP_ENV = process.env.REACT_APP_APP_ENV || '';
export const DEBUG_ANALYTICS_LOG = process.env.REACT_APP_DEBUG_ANALYTICS_LOG === 'true';
export const PROCESS_ENV = process.env.NODE_ENV;
export const IS_DEVELOPMENT = PROCESS_ENV === 'development';
